import Roller from 'vue-roller'

export default {
  components: {
    Roller
  },
  data() {
    return {
      nameArr : ['total', 'mega', 'major', 'minor', 'mini'],
      updateGold: {
        total: '',
        mega: '',
        major: '',
        minor: '',
        mini: ''
      },
      defaultGold: {
        total: '',
        mega: '',
        major: '',
        minor: '',
        mini: ''
      },
    }
  },
  methods: {
    numberWithComma(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    randomNumber() {
      return Math.floor(Math.random() * (10 - 2) + 1)
    },
  },
  async created() {
    try {
      const { data } = await this.$http.get('/v1/event/jackpot')
      this.nameArr.forEach((name) => {
        this.defaultGold[name] = data.jackpot[name] - Math.round(data.jackpot[name] * .01)
      })
    } catch (e) {
      console.log('jackpot fetch Gold error1', e)
      this.nameArr.forEach((name) => {
        this.defaultGold[name] = 0
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.nameArr.forEach((name) => {
        this.updateGold[name] = this.defaultGold[name]
      })
    }, 2900)

    window.updateJackpot =  setInterval(() => {
      this.updateGold.mega += Math.floor(Math.random() * (10 - 2) + 1)
      this.updateGold.major += Math.floor(Math.random() * (10 - 4) + 1)
      this.updateGold.minor += Math.floor(Math.random() * (10 - 6) + 1)
      this.updateGold.mini += Math.floor(Math.random() * (10 - 8) + 1)
      this.updateGold.total = this.updateGold.mega + this.updateGold.major + this.updateGold.minor + this.updateGold.mini
    }, 3000)
  },
  destroyed() {
    clearInterval(window.getJackpot)
    clearInterval(window.updateJackpot)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jackpot-rolling.js